import React from 'react';
import styles from '../../index.module.scss';
import Button from 'components/Button';
import Icon from 'components/Icon';
import toolsEventMap from 'components/ReaderTools/toolsEventMap';
import { useGAEvent } from 'components/AppService/GAService';

import {withTranslation} from 'react-i18next';

import { active } from '../ActivatableReaderToolComponent';

const ReaderToolInsertComponent = ({ t, currentReaderToolType, type }) => {
    const { gaEvent } = useGAEvent();
    const tool = toolsEventMap[type];
    return (
        <Button
            title={t(tool.title)}
            key={type}
            inlineStyle={currentReaderToolType === type && active}
            onClick={() => {
                if (tool.ga) gaEvent(tool.ga);
                tool.clickHandler();
            }}
        >
            <Icon name={tool.icon} />
            <div className={styles.text}>{t(tool.title)}</div>
        </Button>
    );
};

export default withTranslation()(ReaderToolInsertComponent);
